var e = /* @__PURE__ */ ((l) => (l.Default = "default", l.Full = "full", l))(e || {});
export {
  e as VariantsEnum
};
